import { CARD_SIZES } from './card.styles'

export const getCardStylesBySize = (sizeName: keyof typeof CARD_SIZES) => {
  return CARD_SIZES[sizeName]
}
